import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
import { useIdentificationFieldVisibility } from "@Client/@Composables/application-standalone/pages/identifications/useIdentificationFieldVisibility";
import { useBindApplication } from "@Client/@Composables/application-standalone/useBindApplication";
import { APPLICATION_PATH } from "@Client/@Utils/enums/application-paths";
import { computed, ref } from "@vue/composition-api";
import { useI18n } from "vue-i18n-composable";
export const useIdentificationHelpers = () => {
  const {
    addNestedField,
    removeNestedField
  } = useBindApplication();
  const {
    t
  } = useI18n();
  const {
    applicationHasCoApplicants
  } = useApplicantHelpers();
  const addEmptyIdentification = applicantIndex => {
    const currentApplicantPath = applicantIndex === 0 ? APPLICATION_PATH.MAIN_APPLICANT : APPLICATION_PATH.CO_APPLICANTS + `[${applicantIndex - 1}]`;
    addNestedField(currentApplicantPath + "[identifications]");
  };
  const deleteIdentification = (applicantIndex, identificationIndex) => {
    const currentApplicantPath = applicantIndex === 0 ? APPLICATION_PATH.MAIN_APPLICANT : APPLICATION_PATH.CO_APPLICANTS + `[${applicantIndex - 1}]`;
    removeNestedField(currentApplicantPath + "[identifications]", identificationIndex);
  };
  const identificationSummarySubtitle = identification => {
    var _context;
    const type = t(`application-form.${identification["type"] || "identification-type"}`);
    const country = identification["country"] || "";
    const number = identification["number"] || "";
    return _filterInstanceProperty(_context = [type, country, number]).call(_context, el => !!el).join(" | ");
  };
  const applicantHasIdentification = identifications => (identifications == null ? void 0 : identifications.length) > 0;
  const isIdentificationSectionVisibleForMainApplicant = computed(() => {
    const {
      isIdentificationSectionVisibleForApplicant
    } = useIdentificationFieldVisibility({
      applicantIndex: ref(0),
      identificationIndex: ref(0)
    });
    return isIdentificationSectionVisibleForApplicant.value;
  });
  const isIdentificationSectionVisibleForCoApplicants = computed(() => {
    if (!applicationHasCoApplicants.value) return false;
    const {
      isIdentificationSectionVisibleForApplicant
    } = useIdentificationFieldVisibility({
      applicantIndex: ref(1),
      identificationIndex: ref(0)
    });
    return isIdentificationSectionVisibleForApplicant.value;
  });
  return {
    addEmptyIdentification,
    deleteIdentification,
    identificationSummarySubtitle,
    applicantHasIdentification,
    isIdentificationSectionVisibleForMainApplicant,
    isIdentificationSectionVisibleForCoApplicants
  };
};